// src/NameDetails.js
import React, { useState, useEffect } from 'react';
import docuDetails from './docu';
import axios from 'axios';
// import Skills from './Skills'

function DocumDetails() {
  const [selectedName, setSelectedName] = useState('');
  const [details, setDetails] = useState(null);
  const [fileContent, setFileContent] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedName(selectedValue);

    // Find the details corresponding to the selected name
    const selectedDetails = docuDetails.find((entry) => entry.name === selectedValue);

    // Update the state with the selected details
    setDetails(selectedDetails);
  };

  const handleSignDocument = async (e) => {
    await axios.post('https://cute-halva-229db0.netlify.app/.netlify/functions/api/sign',{email:""});
    
  }
  
  useEffect(() => {
    if (selectedName) {
      setLoading(true);
      axios.get(`${selectedName.toLowerCase()}.txt`) // Assumes filenames match names in lowercase
        .then((response) => {
          setFileContent(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Failed to load file:', error);
          setFileContent('Failed to load file.');
          setLoading(false);
        });
    }
  }, [selectedName]);

  return (
    <div>
      <h3>Review a Document</h3>
      <select value={selectedName} onChange={handleChange}>
        <option value="">Select document</option>
        {docuDetails.map((entry, index) => (
          <option key={index} value={entry.name}>
            {entry.name}
          </option>
        ))}
      </select>
      {details && (
        <div>
            <ul>
                <li>
                <h3>Letter for {selectedName}</h3>
          <p>Signed: {details.isSigned}</p>
          
          <p> </p>
          <textarea class="form-control" contentEditable="true" id="exampleFormControlTextarea1" rows="12" value={fileContent}></textarea>
           {/* <button onClick={() => handleSignDocument(details.id)}>Sign</button> */}
                </li>
            </ul>
         
        </div>
      )}
      
        
        
      {/* {selectedName && (
       <ul><li>
          <h3>Click to Sign for {selectedName}</h3> <button className='btn btn-info' onClick={() => handleSignDocument(details.id)}>Sign</button>
          {loading ? (
            <p>Loading file...</p>
          ) : (
            <Skills fileContent={fileContent} />
            
          )}
        </li></ul>
      )} */}
      
    </div>
  );
}

export default DocumDetails;
